// Shipments getters
/* eslint-disable */
export default {
  get_shipments_list: (state) => state.items,
  get_shipments_count: (state) => state.count,
  get_shipments_ids_of_all_records: (state) => state.ids_of_all_records,
  get_booking_systems: (state) => state.systems,
  get_drafts_list: (state) => state.drafts.items,
  get_drafts_count: (state) => state.drafts.count,
  get_unapproved_list: (state) => state.unapproved.items,
  get_unapproved_count: (state) => state.unapproved.count,
  get_single_shipment: (state) => state.singleShipment,
  get_shipment_dangerous_goods: (state) => (groupId) => {
    return state.singleShipment.package_groups.filter((g) => g.id == groupId)[0]
  },
  get_additional_file_types: (state) => state.additionalFileTypes,
  get_waybill_printers: (state) => {
    return state.waybillPrinters.map(opt => {
      return {text: opt.name, value: opt.id};
    });
  },
  // get_senders: (state) => state.count,
  get_shippers: (state) => state.shippers,
  get_pallet_types: (state) => state.palleteTypes,
  get_pallet_options: (state) => {
    const arrayOptions = [];
    Object.keys(state.palleteTypes).forEach(key => {
      arrayOptions.push({
        text: key, value: key,
      })
    });
    return arrayOptions;
  },
  get_parcel_types: (state) => state.parcelTypes,
  get_parcel_type_name: (state) => (id) => {
    let name = null;
    if (state.parcelTypes !== null) {
      Object.keys(state.parcelTypes.carrier_packaging).forEach((provider) => {
        Object.keys(provider).forEach((packaging) => {
          if (packaging.id === id) name = packaging.name;
        });
      })
      state.parcelTypes.our_packaging.forEach((packaging) => {
        if (packaging.id === id) name = packaging.name;
      })
    }
    return name;
  },
  get_dangerous_goods_option_by_id: (state) => (id) => state.dangerousGoodsOptions.filter((g) => g.id === id)[0],
  get_dangerous_goods_service_by_id: (state) => (id) => state.dangerousGoodsServices.filter((g) => g.id === Number(id))[0],
  get_dangerous_goods_options: (state) => state.dangerousGoodsOptions.map((dg) => ({ text: dg.full_name_for_view, value: dg.id })),
  get_dangerous_goods_types: (state) => state.dangerousGoodsTypes,
  get_dangerous_goods_options_by_type: (state) => (dgType, isLq, isEq) => state.dangerousGoodsOptions
    .filter((dg) => {
      let cond1 = true;
      let cond3 = true;
      let cond2 = dg.types.includes(dgType);
      if (isLq) {
        //Include batteries in limited quantity
        cond1 = (dg.lq_limit !== null) || (['SP188', 'LITHIUM'].includes(dg.dg_category))
      }

      if (isEq) {
        cond3 = dg.eq_outer_limit !== '';
      }

      return cond1 && cond2 && cond3;
    }).map((dg) => ({ text: dg.full_name_for_view, value: dg.id })),
  get_dangerous_goods_packing_types: (state) => state.dangerousGoodsPackingTypes,
  get_dangerous_goods_services: (state) => state.dangerousGoodsServices.map((service) => ({ category: service.category, value: service.id })),
  // end of day
  get_end_of_day_list: (state) => state.endOfDayList,
  get_end_of_day: (state) => state.endOfDay,
  get_end_of_day_shipments: (state) => state.eodShipments.items,
  get_end_of_day_shipments_count: (state) => state.eodShipments.count,
  // CONSOLIDATIONS
  get_consolidations_list: (state) => state.consolidationsList,
  get_consolidation: (state) => state.consolidation.consolidation,
  get_consolidation_barcode: (state) => state.consolidation.barcode,
  get_consolidation_waybill: (state) => state.consolidation.waybill,
  get_consolidation_shipments: (state) => state.consolidationShipments.items,
  get_consolidation_shipments_count: (state) => state.consolidationShipments.count,
  get_consolidation_email_status: (state) => state.consolidation.cons_email_status,
  get_consolidation_product_types: (state) => state.consolidation.cons_product_types,
  // SHIPMENT
  get_editing_shipment: (state) => JSON.parse(JSON.stringify(state.shipmentCompareTemplate)), //state should never been accessed directly, remove reference from object
  get_shipment_editing_mode: (state) => state.shipmentEditMode,
};
